import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Heading } from "@/components/atoms/heading";
import { DocumentCard } from "@/components/molecules/document/document.card";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { useShiftsForProject } from "@/lib/query/shift/use-shifts-for-project";

export function ProjectInfoTab({ projectId }: { projectId: string }) {
  const { t } = useTranslation();

  const { data: project } = useQuery({
    queryKey: ["project", projectId],
    queryFn: () => extractionWrapper(api.project.get(projectId)),
    enabled: !!projectId,
  });

  const { data: shifts } = useShiftsForProject(projectId);

  const { data: documents, error } = useQuery({
    queryKey: ["documents", projectId],
    queryFn: () => extractionWrapper(api.document.getAll("project", projectId)),
    enabled: !!projectId && !!shifts?.items?.length,
  });

  if (error) {
    return (
      <div className="ion-padding">
        <p className="text-error-100">{t("common:error.loading")}</p>
      </div>
    );
  }

  return (
    <div className="ion-padding">
      <section className="space-y-4">
        <Heading order={2}>{t("common:description.title")}</Heading>
        <p className="text-txt-secondary">{project?.description}</p>
      </section>
      {!!documents?.items?.length && (
        <section className="mt-6">
          <h3 className="mb-4 text-lg font-medium">{t("entity:link.plural.capitalized")}</h3>
          <div className="space-y-2">
            {documents?.items?.map((document) => (
              <DocumentCard key={document.id} document={document} projectId={projectId} />
            ))}
            {documents?.items?.length === 0 && (
              <p className="text-txt-secondary">{t("common:no-documents")}</p>
            )}
          </div>
        </section>
      )}
    </div>
  );
}
